/**
 * Computes the SHA-256 hash of a given string and returns it as a hexadecimal string.
 *
 * @param {string} value - The input string to be hashed.
 * @returns {Promise<string>} A promise that resolves to the hexadecimal representation of the SHA-256 hash.
 *
 */
export const hashValue = async (value: string): Promise<string> => {
  const utf8 = new TextEncoder().encode(value);
  const hashBuffer = await crypto.subtle.digest('SHA-256', utf8);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((byte) => byte.toString(16).padStart(2, '0')).join('');
};
